import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cat'
})
export class CatPipe implements PipeTransform {

  transform(items: any[], cat: string): any[] {     
    if (!items) return null
    return items.filter(i => i.idMealType == cat)
  }

}
